import React, { FC } from "react";
import cx from "classnames";

import { useLanguageContext } from "~/context/LanguageContext/LanguageContext";
import { SelectLanguage } from "../SelectLanguage/SelectLanguage";
import { useMerchantSettingsContext } from "~/context/MerchantSettingsContext/MerchantSettingsContext";
import { HorizontalRule } from "~/ui-kit/components/HorizontalRule/HorizontalRule";
import { useThemeContext } from "~/context/ThemeContext/ThemeContext";
import { emptyCallback } from "~/util/emptyCallback";

import "./ReturnsLayout.scss";

export type ReturnsLayoutProps = {
  className?: string;
  renderFooter?: () => JSX.Element;
  addLogoLink?: boolean;
};

export const ReturnsLayout: FC<ReturnsLayoutProps> = ({
  children,
  className = "",
  renderFooter,
  addLogoLink,
}) => {
  const { language, changeLanguage } = useLanguageContext();
  const { logoUrl } = useThemeContext();
  const {
    data: {
      viewSettings: { shopUrl },
      merchant: { merchantLanguages },
    },
  } = useMerchantSettingsContext();

  const hasMoreThanOneLanguage = (merchantLanguages ?? []).length > 1;
  return (
    <div className={cx("card", className)}>
      <div className="card-header border-0 bg-transparent border-light">
        <div className="d-flex flex-column px-2">
          <div className="d-flex justify-content-between align-items-center py-2">
            <div
              className="header-logo-container cursor-pointer"
              onClick={
                addLogoLink && shopUrl
                  ? () => window.open(shopUrl)
                  : emptyCallback
              }
            >
              <img className="header-logo" src={logoUrl} />
            </div>
            <div className="header-language-container">
              {hasMoreThanOneLanguage ? (
                <SelectLanguage
                  merchantLanguages={merchantLanguages}
                  onChange={changeLanguage}
                  selected={language}
                />
              ) : null}
            </div>
          </div>
          <HorizontalRule className="px-2" />
        </div>
      </div>
      <div className="card-body p-0">{children}</div>
      {renderFooter ? (
        <div className={cx("card-footer bg-transparent border-light")}>
          {renderFooter()}
        </div>
      ) : null}
    </div>
  );
};
